import { render, staticRenderFns } from "./CreatePart10_8.vue?vue&type=template&id=7aa05b6d&"
import script from "./CreatePart10_8.vue?vue&type=script&lang=js&"
export * from "./CreatePart10_8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports